import gql from 'graphql-tag';

export const GET_CAMPAIGN = gql`
    query Campaign($slug: String!) {
        campaignBySlug(slug: $slug) {
            slug
            name
            headerImgUrl
            textConfig {
                deliveryLabel
                emailLabel
                emailDescription
                nameLabel
                nameDescription
                sellerGroupLabel
                sellerGroupDescription
                sellerGroupPlaceholder
                addressLabel
                scoreboard
                info
                sellerGroupLabel
                sellingDisabled
                variantUnavailable
                delivery
            }
            openGraphTags {
                title
                description
                imageUrl
            }
            articles {
                _id
                name
                price
                ... on Article {
                    imageUrls
                    description
                    itemsLeft
                    groupId
                    features {
                        key
                        value
                        type
                        label
                    }
                    heading
                }
            }
            deliveryOptions {
                deliveryMethods
                deliveryCountries
                deliveryRadii {
                    centralAddress {
                        description
                        coordinates
                    }
                    radius
                }
                minimumTotalPrice
            }
            organisation {
                locale
            }
            formFields {
              _id
              label
              description
              placeholder
              isRequired
              isMultiselect
              isDisabled
              options
              type
            }
            timeslots {
                collect {
                    start
                    end
                    badge
                    isDisabled
                }
                deliver {
                    start
                    end
                    badge
                    isDisabled
                }
                eatIn {
                    start
                    end
                    badge
                    isDisabled
                }
            }
            isSellingEnabled
            minimumTotalArticleCount
            minimumOrderValue
            isSellerGroupRequired
            showScoreboard
            winnerCount
            acceptDonations
            interfaceConfig {
                sortFeatures
                hideArticleCounter
            }
            onlyFinalOrderAllowed
        }
    }
`;
